import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  Payment,
  ListPaymentsInput,
  ListPaymentsResponse,
} from '@erp/rpc';

export function usePaymentsList(filters: ListPaymentsInput = {}) {
  const query = useQuery(
    orpc.finance.payments.list.queryOptions({
      input: filters,
    }),
  );

  const payments = query.data?.payments ?? [];
  const total = query.data?.total ?? 0;

  return {
    ...query,
    payments,
    total,
  } satisfies typeof query & {
    data?: ListPaymentsResponse;
    payments: Payment[];
    total: number;
  };
}

export function usePayment(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.finance.payments.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    payment: query.data ?? null,
  } satisfies typeof query & {
    data?: Payment | null;
    payment: Payment | null;
  };
}
